var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { attrs: { id: "app" } },
    [
      _c(
        "keep-alive",
        { attrs: { include: _vm.keepAliveList } },
        [_c("router-view")],
        1
      ),
      _vm._v(" "),
      _c(
        "van-tabbar",
        {
          staticStyle: { "z-index": "11" },
          attrs: { "active-color": "#00c4b6", route: "" },
          model: {
            value: _vm.active,
            callback: function($$v) {
              _vm.active = $$v
            },
            expression: "active"
          }
        },
        [
          _c(
            "van-tabbar-item",
            { attrs: { name: "list", icon: "description", to: "/list" } },
            [_vm._v("清单")]
          ),
          _vm._v(" "),
          _c(
            "van-tabbar-item",
            { attrs: { name: "scrap", icon: "failure", to: "/scrap" } },
            [_vm._v("报废")]
          ),
          _vm._v(" "),
          _c(
            "van-tabbar-item",
            { attrs: { name: "warn", icon: "bulb-o", to: "/warn" } },
            [_vm._v("警报")]
          ),
          _vm._v(" "),
          _c(
            "van-tabbar-item",
            { attrs: { name: "mine", icon: "user-o", to: "/mine" } },
            [_vm._v("我的")]
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "pupop-hint",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.showMessage,
              expression: "showMessage"
            }
          ],
          on: { cancelPupopHint: _vm.closeTitle, getBack: _vm.sureTitle }
        },
        [
          _c(
            "div",
            { staticClass: "title", attrs: { slot: "title" }, slot: "title" },
            [_vm._v(_vm._s(_vm.errorMessage))]
          )
        ]
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-47f05392", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-47f05392","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0&bustCache!./src/mainApp.vue
// module id = null
// module chunks = 